export default __webpack_public_path__ + "static/media/relationshipLife.d6998c57.jpeg";